/* eslint-disable react/no-unescaped-entities */
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
// import { FormattedMessage } from 'react-intl';
import { useExpanded, useTable } from 'react-table';
import ReactTableRender from '../../../../../Components/ReactTable/ReactTableRender';
import { ThematicAreaBadge } from '../../../../../Components/ThematicAreaBadge';

function EventSummaryTable({ eventsSummaryData, loading }) {
  const columns = useMemo(
    () => [
      {
        Header: <FormattedMessage id="sn" />,
        accessor: 'sequenceId',
        width: '2%'
      },
      {
        Header: <FormattedMessage id="output_number" />,

        accessor: 'output_number',
        width: '4%'
      },
      {
        Header: <FormattedMessage id="date" />,

        accessor: 'date',
        Cell: ({ row: { original } }) => {
          return (
            <div className="small">
              {original.startDate} <div className="text-primary font-weight-bolder w-100 ">-</div>{' '}
              {original.endDate}
            </div>
          );
        }
      },
      {
        Header: <FormattedMessage id="title" />,

        accessor: 'title',
        width: '8%'
      },
      {
        Header: <FormattedMessage id="thematic_area" />,

        accessor: 'thematic_areas',
        width: '300px',
        Cell: ({ row, cell: { value } }) => (
          <span className="d-flex align-items-center flex-wrap">
            {Boolean(value) && (
              <>
                {value.length > 3 ? (
                  <span className="small text-secondary" {...row.getToggleRowExpandedProps()}>
                    {row.isExpanded ? (
                      <div>
                        <span>👇</span>
                        <div>
                          {value?.map((target, index) => (
                            <ThematicAreaBadge key={index}>{target}</ThematicAreaBadge>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <div>
                        {Array.isArray(value) &&
                          value
                            ?.slice(0, 3)
                            ?.map((target, index) => (
                              <ThematicAreaBadge key={index}>{target}</ThematicAreaBadge>
                            ))}
                        +{value.length - 3} more 👉
                      </div>
                    )}
                  </span>
                ) : (
                  <span className="small text-secondary" {...row.getToggleRowExpandedProps()}>
                    <div>
                      <div>
                        {value?.map((target, index) => (
                          <ThematicAreaBadge key={index}>{target}</ThematicAreaBadge>
                        ))}
                      </div>
                    </div>
                  </span>
                )}
              </>
            )}
          </span>
        )
      },
      {
        Header: <FormattedMessage id="targeted_for" />,
        accessor: 'targeted_for',
        width: '300px',
        Cell: ({ cell: { value } }) => (
          <span className="d-flex align-items-center flex-wrap">
            {value.split(',').map((val) => (
              <div key={val} className="mb-3">
                {val}
              </div>
            ))}
          </span>
        )
      },
      {
        Header: <FormattedMessage id="event.organized_by" />,
        width: '3%',
        accessor: 'organized_by',
        Cell: ({ cell: { value } }) => (
          <div>
            {value.split(',').map((val) => (
              <div key={val}>{val}</div>
            ))}
          </div>
        )
      },
      {
        Header: <FormattedMessage id="total_benificiaries" />,
        accessor: 'total_benificiaries',
        width: '3%'
      },
      {
        id: 'attended_participant_col',
        Header: <FormattedMessage id="participants_details" />,
        className: 'text-center',
        columns: [
          {
            Header: <FormattedMessage id="male" />,
            width: '3%',

            accessor: 'en_parti_male'
          },
          {
            Header: <FormattedMessage id="female" />,
            width: '3%',

            accessor: 'en_parti_female'
          },
          {
            Header: <FormattedMessage id="gender_minorities" />,
            width: '3%',
            accessor: 'en_parti_other'
          }
        ]
      },
      {
        id: 'participants_ethnicity_col',
        Header: <FormattedMessage id="participants_ethinicity" />,
        width: '3%',
        className: 'text-center',
        columns: [
          {
            id: 'brahmin_chhetri_col',
            Header: ' ',
            columns: [
              {
                Header: <FormattedMessage id="brahmin_chhetri" />,
                width: '3%',

                accessor: 'brahmin_chhetri'
              }
            ]
          },
          {
            id: 'aadhibasi_janajati_col',
            Header: <FormattedMessage id="aadhibasi_janajati" />,
            className: 'text-center',
            width: '3%',
            columns: [
              {
                Header: <FormattedMessage id="hill" />,
                width: '3%',

                accessor: 'aadhibasi_hill'
              },
              {
                Header: <FormattedMessage id="terai" />,
                width: '3%',

                accessor: 'aadhibasi_terai'
              }
            ]
          },
          {
            id: 'dalit_col',
            Header: <FormattedMessage id="dalit" />,
            width: '3%',
            className: 'text-center',
            columns: [
              {
                Header: <FormattedMessage id="hill" />,
                width: '3%',

                accessor: 'dalit_hill'
              },
              {
                Header: <FormattedMessage id="terai" />,
                width: '3%',

                accessor: 'dalit_terai'
              }
            ]
          },
          {
            id: 'madhesi_col',
            Header: ' ',
            columns: [
              {
                Header: <FormattedMessage id="madhesi" />,
                width: '3%',

                accessor: 'madhesi'
              }
            ]
          },
          {
            id: 'muslim_col',
            Header: ' ',
            columns: [
              {
                Header: <FormattedMessage id="muslim" />,
                width: '3%',

                accessor: 'muslim'
              }
            ]
          },
          {
            id: 'others_eth_col',
            Header: ' ',
            columns: [
              {
                Header: <FormattedMessage id="others" />,
                width: '3%',

                accessor: 'others_eth'
              }
            ]
          }
        ]
      },
      {
        Header: <FormattedMessage id="disability" />,
        width: '3%',

        accessor: 'disability'
      },
      {
        Header: <FormattedMessage id="total_resource_person" />,
        accessor: 'total_resource_person',
        Cell: ({ row: { original } }) => (
          <div>
            <div>
              <FormattedMessage id="total" />: {original.en_resor_total}
            </div>
            <div>
              <FormattedMessage id="male" />: {original.en_resor_male}
            </div>
            <div>
              <FormattedMessage id="female" />: {original.en_resor_female}
            </div>
            <div>
              <FormattedMessage id="other" />: {original.en_resor_other}
            </div>
          </div>
        )
      },
      {
        Header: <FormattedMessage id="estimated_vs_actual_budget" />,
        accessor: 'estimated_vs_actual_budget',
        Cell: ({ cell: { value } }) => (
          <div>
            <div>Rs. {value.estimated_budget}</div>
            <div>Vs</div>
            <div>{value.actual_budget}</div>
          </div>
        )
      },
      {
        Header: <FormattedMessage id="status" />,
        accessor: 'status'
      }
    ],
    []
  );

  const data = useMemo(() => {
    if (!eventsSummaryData) return [];
    let count = 1;
    return eventsSummaryData.map((result) => {
      return {
        sequenceId: count++,
        output_number: result.output_number,
        startDate: result.event_start_date,
        endDate: result.event_end_date,
        title: result.title,
        estimated_vs_actual_budget: {
          actual_budget: result.actual_budget,
          estimated_budget: result.estimated_budget
        },
        organized_by: result.organized_by,
        status: result.status,
        total_benificiaries: result.participant_details.total,
        total_days: result.total_days,
        en_parti_male: result.participant_details.male,
        en_parti_female: result.participant_details.female,
        en_parti_other: result.participant_details.other,
        brahmin_chhetri: result.participant_details['brahmin_chhetri'],
        aadhibasi_hill: result.participant_details['aadhibasi_hill'],
        aadhibasi_terai: result.participant_details['aadhibasi_terai'],
        dalit_hill: result.participant_details['dalit_hill'],
        dalit_terai: result.participant_details['dalit_terai'],
        madhesi: result.participant_details.madhesi,
        muslim: result.participant_details.muslim,
        others_eth: result.participant_details.others,
        disability: result.disability,
        en_resor_male: result.resource_person_details.male,
        en_resor_female: result.resource_person_details.female,
        en_resor_other: result.resource_person_details.other,
        en_resor_samuha: result.resource_person_details.samuha,
        en_resor_total: result.resource_person_details.total,
        location: 'N/A',
        targeted_for: result.targeted_sector,
        thematic_areas: (result.thematic_areas || '').split(',')
      };
    });
  }, [eventsSummaryData]);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, visibleColumns } =
    useTable(
      {
        columns,
        data
      },
      useExpanded
    );

  return (
    <div className="mt-3">
      <ReactTableRender
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        getTableBodyProps={getTableBodyProps}
        page={rows}
        prepareRow={prepareRow}
        visibleColumns={visibleColumns}
        pagination={false}
        loading={loading}
        maxContent={true}
        noFilters={true}
      />
    </div>
  );
}

export default EventSummaryTable;
